import type { InputGroupDesignTokens } from '@primeuix/themes/types/inputgroup';

export const INPUTGROUP_STYLES: InputGroupDesignTokens = {
  css: () => `
    /* Shrink addon to match small inputnumber — addon has no built-in sm variant */
    .p-inputgroup:has(.p-inputtext-sm) .p-inputgroupaddon {
        padding-block: 0.328125rem;  /* 5.25px — matches --p-inputtext-sm-padding-y */
        padding-inline: 0.546875rem; /* 8.75px — matches --p-inputtext-sm-padding-x */
        font-size: 0.8125rem;        /* 13px   — matches --p-inputtext-sm-font-size */
    }`,
};
